<template>
  <v-row class="pt-0">
    <v-col v-if="useTitle" cols="12" md="12" class="pa-0 pt-0">
      <prepareTitle :title="title">
        <template v-slot:add><slot name="add"></slot></template>
      </prepareTitle>
    </v-col>
    <!-- 변경된 값을 위해서 사용함  -->
    <span hidden>{{ updateValue }}</span>
    <v-col cols="12" md="12" class="pt-0 px-2">
      <!-- auto-grow : 자동 크기 조절  -->
      <v-textarea
        no-resize
        clearable
        :disabled="disabled"
        clear-icon="mdi-close-circle-outline"
        outlined
        name="input-7-4"
        :label="label"
        v-model="_content"
        :rows="rows"
        :row-height="rowHeight"
        @click:clear="callItBack()"
      ></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
import prepareTitle from './prepareTitle.vue'
export default {
  name: 'i-prepare_textarea',
  components: { prepareTitle },
  props: {
    title: {
      type: String,
      default: '제목없음'
    },
    content: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 4
    },
    rowHeight: {
      type: Number,
      default: 30
    },
    inputValue: Function,
    useTitle: {
      type: Boolean,
      default: true
    },
    disabled: {
      default: false
    }
  },
  data() {
    return { value: '' }
  },
  mounted() {
    //    console.log('mounted!')
  },
  computed: {
    _content: {
      get() {
        return this.value
      },
      set(value) {
        //console.log('set', this.content)
        this.value = value
      }
    },
    updateValue() {
      //console.log('updateValue', this.content)
      this.value = this.content
    }
  },
  watch: {
    value: function(value) {
      this.inputValue(this.value)
    }
  },
  methods: {
    setValue(value) {
      this.value = value
    },
    callItBack() {}
    // up() {
    //   this.$nextTick(() => {
    //     //this.inputValue(this.value)
    //   })
    // }
  }
}
</script>
